"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _Calendar = _interopRequireDefault(require("@insided/destination/icons/Calendar"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fpConfig = {
  minDate: 'today',
  altInput: true,
  altFormat: 'M d, Y',
  allowRange: false,
  static: true,
  nextArrow: "<svg width=\"7\" height=\"10\" viewBox=\"0 0 7 10\" fill=\"#333333\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M1.3332 0L0.158203 1.175L3.97487 5L0.158203 8.825L1.3332 10L6.3332 5L1.3332 0Z\"/>\n      </svg>",
  prevArrow: "<svg width=\"7\" height=\"10\" viewBox=\"0 0 7 10\" fill=\"#333333\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M6.8415 1.175L5.6665 0L0.666504 5L5.6665 10L6.8415 8.825L3.02484 5L6.8415 1.175Z\"/>\n      </svg>"
};
var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var DatePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    (0, _classCallCheck2.default)(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "currentDateSpan", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closed", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "instance", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "flatpickr", null);
    return _this;
  }

  (0, _createClass2.default)(DatePicker, [{
    key: "loadFlatpickr",
    value: // Store flatpickr module reference
    function () {
      var _loadFlatpickr = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.flatpickr) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return import('flatpickr');

              case 3:
                this.flatpickr = _context.sent.default;

              case 4:
                return _context.abrupt("return", this.flatpickr);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadFlatpickr() {
        return _loadFlatpickr.apply(this, arguments);
      }

      return loadFlatpickr;
    }() // eslint-disable-next-line class-methods-use-this

  }, {
    key: "componentShouldUpdate",
    value: function componentShouldUpdate() {
      return false;
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      if (this.instance && nextProps.defaultDateRange) {
        if (!isNaN(nextProps.defaultDateRange[0].getTime()) && !isNaN(nextProps.defaultDateRange[1].getTime())) {
          this.instance.setDate(nextProps.defaultDateRange);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(prevProps) {
        var _this$props, setManuallyFromProps, initialValue, value, flatpickr, dateParsed, _this$instance;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, setManuallyFromProps = _this$props.setManuallyFromProps, initialValue = _this$props.initialValue, value = _this$props.value;

                if (!(setManuallyFromProps && initialValue && value && prevProps.value !== value && this.instance)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return this.loadFlatpickr();

              case 4:
                flatpickr = _context2.sent;
                dateParsed = flatpickr.parseDate(initialValue);

                if (dateParsed) {
                  this.instance.setDate(dateParsed, false);
                }

              case 7:
                if (this.props.minDate) {
                  (_this$instance = this.instance) === null || _this$instance === void 0 ? void 0 : _this$instance.set('minDate', this.props.minDate);
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        var _this$props$onSetFPIn, _this$props3, flatpickr, _this$props2, _onChange, value, allowPastDates, disableInput, allowRange, maxDate, defaultDateRange, format, _this$props2$showMont, showMonths, _this$props2$allowInp, allowInput, minDate, effectiveMinDate, _fp;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.input) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 3;
                return this.loadFlatpickr();

              case 3:
                flatpickr = _context3.sent;
                _this$props2 = this.props, _onChange = _this$props2.onChange, value = _this$props2.value, allowPastDates = _this$props2.allowPastDates, disableInput = _this$props2.disableInput, allowRange = _this$props2.allowRange, maxDate = _this$props2.maxDate, defaultDateRange = _this$props2.defaultDateRange, format = _this$props2.format, _this$props2$showMont = _this$props2.showMonths, showMonths = _this$props2$showMont === void 0 ? 1 : _this$props2$showMont, _this$props2$allowInp = _this$props2.allowInput, allowInput = _this$props2$allowInp === void 0 ? true : _this$props2$allowInp, minDate = _this$props2.minDate; // Determine effective minDate: use explicit minDate prop if provided,
                // otherwise fall back to 'today' if allowPastDates is false

                effectiveMinDate = minDate !== null && minDate !== void 0 ? minDate : allowPastDates ? undefined : fpConfig.minDate;
                _fp = flatpickr(this.input, _objectSpread(_objectSpread({}, fpConfig), {}, {
                  allowInput: allowInput,
                  altFormat: format !== null && format !== void 0 ? format : fpConfig.altFormat,
                  minDate: effectiveMinDate,
                  maxDate: allowRange ? maxDate : undefined,
                  mode: allowRange ? 'range' : 'single',
                  defaultDate: allowRange ? defaultDateRange : value,
                  inline: disableInput,
                  showMonths: showMonths,
                  onReady: function onReady(_selectedDates, _dateStr, instance) {
                    var _currentYearElement$p;

                    _this2.instance = instance;
                    var currentMonth = instance.currentMonth,
                        currentYear = instance.currentYear,
                        monthsDropdownContainer = instance.monthsDropdownContainer,
                        currentYearElement = instance.currentYearElement;
                    _this2.currentDateSpan = document.createElement('span');

                    _this2.currentDateSpan.classList.add('current-date');

                    _this2.currentDateSpan.innerHTML = "".concat(_this2.getMonthName(currentMonth), " ").concat(currentYear);
                    monthsDropdownContainer === null || monthsDropdownContainer === void 0 ? void 0 : monthsDropdownContainer.replaceWith(_this2.currentDateSpan);
                    currentYearElement === null || currentYearElement === void 0 ? void 0 : (_currentYearElement$p = currentYearElement.parentElement) === null || _currentYearElement$p === void 0 ? void 0 : _currentYearElement$p.remove();

                    if (_this2.props.isBrand) {
                      var _document$querySelect;

                      (_document$querySelect = document.querySelector('.flatpickr-calendar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('brand');
                    } // const newInput = document.querySelector('input.control-date-picker.form-control.input')
                    // newInput?.addEventListener('focusout', () => {
                    //   const evt = new KeyboardEvent('keydown', { which: 13, keyCode: 13, bubbles: true })
                    //   newInput.dispatchEvent(evt)
                    // })

                  },
                  onMonthChange: function onMonthChange(_selectedDates, _dateStr, instance) {
                    _this2.updateMonthAndYearElement(instance);
                  },
                  onChange: function onChange(selectedDates, _dateStr, instance) {
                    _this2.updateMonthAndYearElement(instance);

                    _onChange(selectedDates);
                  },
                  onClose: function onClose() {
                    return _this2.closed = Date.now();
                  }
                }));
                (_this$props$onSetFPIn = (_this$props3 = this.props).onSetFPInstance) === null || _this$props$onSetFPIn === void 0 ? void 0 : _this$props$onSetFPIn.call(_this$props3, _fp);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "toggleOpen",
    value: function toggleOpen() {
      var _this$instance2;

      Date.now() - this.closed > 200 && ((_this$instance2 = this.instance) === null || _this$instance2 === void 0 ? void 0 : _this$instance2.open());
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getMonthName",
    value: function getMonthName(monthIndex) {
      return MONTH_NAMES[monthIndex];
    }
  }, {
    key: "updateMonthAndYearElement",
    value: function updateMonthAndYearElement(instance) {
      var currentMonth = instance.currentMonth,
          currentYear = instance.currentYear; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      this.currentDateSpan.innerHTML = "".concat(this.getMonthName(currentMonth), " ").concat(currentYear);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          error = _this$props4.error,
          classes = _this$props4.classes,
          disableInput = _this$props4.disableInput,
          allowRange = _this$props4.allowRange,
          showMonths = _this$props4.showMonths;
      var additionalClasses = classes !== null && classes !== void 0 ? classes : [];
      return (0, _preact.h)("div", {
        className: _classnames.default.apply(void 0, [{
          'validation-error': error,
          'date-picker-two-months': showMonths === 2
        }, 'control-date-picker-input-wrapper'].concat((0, _toConsumableArray2.default)(additionalClasses)))
      }, !disableInput && (0, _preact.h)("a", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this3.toggleOpen();
        },
        onKeyDown: function onKeyDown(e) {
          return e.key === 'Enter' && _this3.toggleOpen();
        }
      }, (0, _preact.h)(_Calendar.default, {
        className: "icon-calendar"
      })), !disableInput && (0, _preact.h)("a", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this3.toggleOpen();
        },
        onKeyDown: function onKeyDown(e) {
          return e.key === 'Enter' && _this3.toggleOpen();
        }
      }, (0, _preact.h)(_ChevronDown.default, {
        className: "icon-dropdown",
        width: 16
      })), (0, _preact.h)("input", {
        className: (0, _classnames.default)('control-date-picker', {
          'input-hidden': disableInput && !allowRange
        }),
        placeholder: "Select a date",
        ref: function ref(input) {
          return _this3.input = input;
        }
      }));
    }
  }]);
  return DatePicker;
}(_preact.Component);

exports.default = DatePicker;